export default [
  {
    name: 'YARD CLEANUP',
    prompt: 'YARD CLEANUP',
    image: 'https://cdn.bidmii.com/media/web_assets/landscaping_720x720.webp',
    key: 'landscaping',
    tags: ['TIDY', 'YARD', 'OUTSIDE'],
  },
  {
    name: 'PAINTING',
    prompt: 'PAINT A ROOM',
    image: 'https://cdn.bidmii.com/media/web_assets/painting_720x720.webp',
    key: 'painting',
    tags: ['PAINT', 'WALLS', 'ROOM'],
  },
  {
    name: 'FLOORING',
    prompt: 'FLOORING',
    image: 'https://cdn.bidmii.com/media/web_assets/flooring_720x720.webp',
    key: 'flooring',
    tags: ['FLOORING', 'RENO'],
  },
  {
    name: 'GARAGE MAKEOVER',
    prompt: 'GARAGE MAKEOVER',
    image:
      'https://cdn.bidmii.com/media/web_assets/garage-makeover_720x720.webp',
    key: 'garageMakeover',
    tags: ['MAKEOVER', 'GARAGE', 'CUSTOM'],
  },
  {
    name: 'BATHROOM RENO',
    prompt: 'BATHROOM RENO',
    image: 'https://cdn.bidmii.com/media/web_assets/bathroom-reno_720x720.webp',
    key: 'bathroomReno',
    tags: ['BATHROOM', 'RENO'],
  },
  {
    name: 'ROOFING',
    prompt: 'ROOFING',
    image: 'https://cdn.bidmii.com/media/web_assets/roofing_720x720.webp',
    key: 'roofing',
    tags: ['REPLACE', 'ROOF'],
  },
  {
    name: 'WINDOW REPLACEMENT',
    prompt: 'WINDOW REPLACEMENT',
    image:
      'https://cdn.bidmii.com/media/web_assets/window_replacement_720x720.webp',
    key: 'window_replacement',
    tags: ['REPLACE', 'WINDOW'],
  },
  {
    name: 'WINDOW WASHING',
    prompt: 'WINDOW CLEANING',
    image:
      'https://cdn.bidmii.com/media/web_assets/window-washing_720x720.webp',
    key: 'windowWashing',
    tags: ['WASH', 'WINDOWS', 'EXTERIOR'],
  },
  {
    name: 'DRIVEWAY SEALING',
    prompt: 'DRIVEWAY SEALING',
    image:
      'https://cdn.bidmii.com/media/web_assets/driveway-sealing_720x720.webp',
    key: 'drivewaySealing',
    tags: ['SEAL', 'ASPHALT', 'DRIVEWAY'],
  },
];
